import { render, staticRenderFns } from "./acyeterionList-add.vue?vue&type=template&id=1f74563e&"
import script from "./acyeterionList-add.vue?vue&type=script&lang=js&"
export * from "./acyeterionList-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports